import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const ActionDownArrowIcon = (props) => {
  const {themeName,getThemeColor} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5ZM4.5 6.75L7.5 9.75L10.5 6.75H4.5Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default ActionDownArrowIcon;
